<h2 mat-dialog-title>Sign in another session</h2>
<mat-dialog-content>
    <!-- Camera viewport -->
    <div id="qr-reader" *ngIf="!scanning_complete" style="width: 100%;"></div>

    <!-- Status messages -->
    <div class="flex flex-col items-center mt-4" *ngIf="scanning">
        <mat-progress-spinner
            [diameter]="24"
            [mode]="'indeterminate'"
            class="mb-2"></mat-progress-spinner>
        <span class="text-sm text-secondary">Authorizing session...</span>
    </div>

    <div class="flex flex-col items-center mt-4" *ngIf="scanning_complete && !error_message">
        <mat-icon class="text-green-500 icon-size-12" [svgIcon]="'heroicons_outline:check-circle'"></mat-icon>
        <span class="text-md font-medium mt-2">Session authorized successfully!</span>
        <span class="text-sm text-secondary mt-1">The other device will sign in shortly.</span>
    </div>

    <div class="flex flex-col items-center mt-4" *ngIf="error_message">
        <mat-icon class="text-red-500 icon-size-12" [svgIcon]="'heroicons_outline:x-circle'"></mat-icon>
        <span class="text-md font-medium mt-2 text-center">{{ error_message }}</span>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
